import { useEffect, useRef } from "react"
import io from "socket.io-client"
import { useStore } from "../store"
// import { usePOIStore } from "./activePOIStore"

const ThreeSixtyBroadcaster = () => {
  const socket = useRef()
  const url = process.env.REACT_APP_MARKETING_SUITE
  const role = process.env.REACT_APP_ROLE

  const activeCard = useStore(state => state.activeCard)
  const setActiveCard = useStore(state => state.setActiveCard)
  const show360 = useStore(state => state.show360)
  const setShow360 = useStore(state => state.setShow360)
  const showRecipient360 = useStore(state => state.showRecipient360)
  const setShowRecipient360 = useStore(state => state.setShowRecipient360)

  const viewID = useStore(state => state.viewID)
  const setViewID = useStore(state => state.setViewID)

  const kView = useStore(state => state.kView)
  const setKView = useStore(state => state.setKView)

  const showPano = useStore(state => state.showPano)
  const setShowPano = useStore(state => state.setShowPano)
  const openDlg = useStore(state => state.openDlg)
  const setOpenDlg = useStore(state => state.setOpenDlg)

  const index360 = useStore(state => state.index360)
  const setIndex360 = useStore(state => state.setIndex360)

  const state = {
    show360: show360,
    showRecipient360: showRecipient360,
    activeCard: activeCard,
    showPano: showPano,
    openDlg: openDlg,
    index360: index360,
    kView: kView,
    viewID: viewID
  }

  console.log("STATE", state)

  useEffect(() => {
    socket.current = io(url)
    socket.current.emit("subscribe-threesixtyzustand", 1000)
    if (role === "recipient") {
      socket.current.on("threesixtyzustand", actAptZustand => {
        setShow360(actAptZustand.show360)
        setShowRecipient360(actAptZustand.showRecipient360)
        setActiveCard(actAptZustand.activeCard)
        setOpenDlg(actAptZustand.openDlg)
        setShowPano(actAptZustand.showPano)
        setIndex360(actAptZustand.index360)
        setKView(actAptZustand.kView)
        setViewID(actAptZustand.viewID)
      })
    }
    return () => socket.current.close()
  }, [state, role, url])

  useEffect(() => {
    if (role === "sender") {
      socket.current.emit("threesixtyzustand", state)
    }
  }, [state, role, url])

  return null
}

ThreeSixtyBroadcaster.propTypes = {}

export default ThreeSixtyBroadcaster
